import categoryIcons from '../Utils/categoryIcons';

function hexToRgba(hex, alpha) {
  const h = String(hex || '#8e8e93').replace('#', '');
  if (h.length < 6) return `rgba(142, 142, 147, ${alpha})`;
  const r = parseInt(h.substring(0, 2), 16);
  const g = parseInt(h.substring(2, 4), 16);
  const b = parseInt(h.substring(4, 6), 16);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}

export default function TarjetaCategoria({ name, icon, color, onClick }) {
  const IconComp = icon ? categoryIcons[icon] : null;
  const badgeColor = color || '#8e8e93';
  const monogram = String(name || '?').trim().slice(0, 1).toUpperCase();

  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={`Abrir categoría ${name}`}
      className="flex flex-col items-center justify-center gap-3 w-full min-w-0 rounded-3xl border-none p-4 cursor-pointer touch-manipulation select-none transition-colors duration-200 ease-out active:scale-[0.98] bg-[#141414] [@media(hover:hover)]:hover:bg-[#181818]"
      style={{ fontFamily: '"Public Sans", sans-serif', aspectRatio: '1 / 1' }}
    >
      <span
        className="flex items-center justify-center shrink-0 w-16 h-16 rounded-full"
        style={{ backgroundColor: hexToRgba(badgeColor, 0.16) }}
      >
        {IconComp ? (
          <IconComp size={28} color={badgeColor} />
        ) : (
          <span style={{ fontSize: '24px', fontWeight: 700, color: badgeColor }}>{monogram}</span>
        )}
      </span>
      <span
        className="block font-semibold text-center truncate max-w-full"
        style={{
          fontSize: '15px',
          lineHeight: '20px',
          letterSpacing: '-0.01em',
          color: 'rgba(255, 255, 255, 0.92)',
        }}
        title={name}
      >
        {name}
      </span>
    </button>
  );
}
